<template>
  <v-app :class="prefix">
    <!-- private -->
    <v-app-bar
      v-if="useremail !== ''"
      height="80"
      app
      color="grey lighten-4"
      elevate-on-scroll>
      <v-container class="mx-auto py-0">
        <v-row class="align-center">
          <v-col cols="12" md="12" class="d-flex align-center px-md-0 py-md-0">
            <router-link :to="{ name: 'Landing' }" class="d-inline-flex align-center text-decoration-none">
              <img class="mr-3" :src="require('./assets/logo-pnb.png')" height="60" :alt="apptitle"/>
              <v-toolbar-title v-show="!$vuetify.breakpoint.smAndDown">
                <div class="title-style-pnb title-style-pnb text-uppercase">{{ apptitle }}</div>
                <div class="title-style-pnb subtitle-style-pnb">{{ appsubtitle }}</div>
              </v-toolbar-title>
              <v-toolbar-title v-show="$vuetify.breakpoint.smAndDown">
                <div class="title-style-pnb title-style-pnb">PNB</div>
              </v-toolbar-title>
            </router-link>
            <v-spacer></v-spacer>
            <v-col
              class="text-right">
              <ul class="top-nav-list">
                <li>
                  <SwitchLanguage />
                </li>
              </ul>
            </v-col>
            <v-btn
              icon
              :to="{ name: btndash }"
              exact>
              <v-icon>mdi-apps</v-icon>
            </v-btn>
            <!-- menu to public -->
            <v-menu
              offset-y
              bottom
              left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  exact>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in pubmenu"
                  :key="i"
                  link
                  :to="item.to"
                  exact>
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- mobile -->
            <v-btn
              v-show="$vuetify.breakpoint.smAndDown"
              icon
              @click.stop="rightDrawer = !rightDrawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <!-- desktop -->
            <v-btn
              icon
              @click.stop="rightDrawer = !rightDrawer">
              <v-icon>menu</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <!-- public -->
    <v-app-bar
      v-if="useremail === ''"
      :height="$vuetify.breakpoint.smAndDown ? 120 : 165"
      app
      flat
      hide-on-scroll>
      <v-container>
        <v-row>
          <v-col cols="12" md="12" class="top-nav-cont py-0 px-md-0" v-show="!$vuetify.breakpoint.smAndDown">
            <v-row>
              <v-col cols="auto">
                <ul class="top-nav-list">
                  <li>
                    <router-link
                      class="text-decoration-none link-list-style"
                      :to="{ name: 'News', query: { type: 'berita', category: 'covid' } }"
                      exact>
                      {{ $t('navigation.infocovid') }}
                    </router-link>
                  </li>
                  <li>
                    <a class="text-decoration-none link-list-style" href="https://sipol.pnb.ac.id/" target="_blank">
                      {{ $t('navigation.complain') }}
                    </a>
                  </li>
                  <li v-if="$i18n.locale === 'id'">
                    <router-link
                      class="text-decoration-none link-list-style"
                      :to="{ name: 'NewsDetail', query: { berita: 180 } }"
                      exact>
                      ZI-WBK
                    </router-link>
                  </li>
                  <li v-if="$i18n.locale === 'id'">
                    <router-link
                      class="text-decoration-none link-list-style"
                      :to="{ name: 'Data' }"
                      exact>
                      Data AL
                    </router-link>
                  </li>
                  <li>
                    <a href="https://elearning.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      e-Learning
                    </a>
                  </li>
                  <li>
                    <a href="https://partnership.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      Career
                    </a>
                  </li>
                  <li>
                    <a href="https://perpustakaan.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      Library
                    </a>
                  </li>
                  <li>
                    <a href="https://repository.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      Repository
                    </a>
                  </li>
                  <li>
                    <a href="https://ojs2.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      Publication
                    </a>
                  </li>
                  <li>
                    <a href="https://simlitabmas.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      Simlitabmas
                    </a>
                  </li>
                  <li>
                    <router-link
                      class="text-decoration-none link-list-style"
                      :to="{ name: 'News' }"
                      exact>
                      {{ $t('navigation.info') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'NewsDetail', query: { berita: 25 } }"
                      class="text-decoration-none link-list-style">
                      <v-badge color="pink" dot>
                        {{ $t('navigation.admission') }}
                      </v-badge>
                    </router-link>
                  </li>
                  <li>
                    <a href="https://ikapnb.com/" class="text-decoration-none link-list-style" target="_blank">
                      {{ $t('navigation.alumni') }}
                    </a>
                  </li>
                  <li>
                    <a href="https://sion.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                      {{ $t('navigation.onlinesys') }}
                    </a>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'NewsDetail', query: { berita: 39 } }"
                      class="text-decoration-none link-list-style">
                      {{ $t('navigation.directory') }}
                    </router-link>
                  </li>
                  <li v-if="useremail === ''">
                    <router-link :to="{ name: 'Login' }" class="text-decoration-none link-list-style">
                      Login
                    </router-link>
                  </li>
                  <li v-if="useremail !== ''">
                    <router-link @click.native="doLogout" :to="{ name: 'Login' }" class="text-decoration-none link-list-style">
                      Logout
                    </router-link>
                  </li>
                </ul>
              </v-col>
              <v-spacer></v-spacer>
              <v-col class="text-right">
                <ul class="top-nav-list">
                  <li>
                    <SwitchLanguage />
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12" class="top-nav-cont py-0 px-0 scrolling-wrapper" v-show="$vuetify.breakpoint.smAndDown">
            <v-tabs
              background-color="transparent"
              hide-slider
              height="30"
              v-if="false">
              <v-tab
                class="text-capitalize"
                :to="{ name: 'News', query: { type: 'berita', category: 'covid' } }"
                exact>
                {{ $t('navigation.infocovid') }}
              </v-tab>
              <v-tab
                class="text-capitalize"
                href="https://elearning.pnb.ac.id/"
                target="_blank"
                exact>
                e-Learning
              </v-tab>
              <v-tab
                class="text-capitalize"
                href="https://partnership.pnb.ac.id/"
                target="_blank"
                exact>
                Career
              </v-tab>
              <v-tab
                class="text-capitalize"
                href="https://perpustakaan.pnb.ac.id/"
                target="_blank"
                exact>
                Library
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'NewsDetail', query: { berita: 25 } }"
                exact>
                {{ $t('navigation.admission') }}
              </v-tab>
            </v-tabs>
            <ul class="top-nav-list py-1">
              <li>
                <router-link
                  class="text-decoration-none link-list-style"
                  :to="{ name: 'News', query: { type: 'berita', category: 'covid' } }"
                  exact>
                  {{ $t('navigation.infocovid') }}
                </router-link>
              </li>
              <li>
                <a class="text-decoration-none link-list-style" href="https://sipol.pnb.ac.id/" target="_blank">
                  {{ $t('navigation.complain') }}
                </a>
              </li>
              <li>
                <router-link
                  class="text-decoration-none link-list-style"
                  :to="{ name: 'NewsDetail', query: { berita: 180 } }"
                  exact>
                  ZI-WBK
                </router-link>
              </li>
              <li>
                <router-link
                  class="text-decoration-none link-list-style"
                  :to="{ name: 'Data' }"
                  exact>
                  Data AL
                </router-link>
              </li>
              <li>
                <a href="https://partnership.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  Career
                </a>
              </li>
              <li>
                <a href="https://perpustakaan.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  Library
                </a>
              </li>
              <li>
                <a href="https://repository.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  Repository
                </a>
              </li>
              <li>
                <a href="https://ojs2.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  Publication
                </a>
              </li>
              <li>
                <a href="https://simlitabmas.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  Simlitabmas
                </a>
              </li>
              <li>
                <router-link
                  class="text-decoration-none link-list-style"
                  :to="{ name: 'News' }"
                  exact>
                  {{ $t('navigation.info') }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'NewsDetail', query: { berita: 25 } }"
                  class="text-decoration-none link-list-style">
                  <v-badge color="pink" dot>
                    {{ $t('navigation.admission') }}
                  </v-badge>
                </router-link>
              </li>
              <li>
                <a href="https://ikapnb.com/" class="text-decoration-none link-list-style" target="_blank">
                  {{ $t('navigation.alumni') }}
                </a>
              </li>
              <li>
                <a href="https://sion.pnb.ac.id/" class="text-decoration-none link-list-style" target="_blank">
                  {{ $t('navigation.onlinesys') }}
                </a>
              </li>
              <li>
                <router-link
                  :to="{ name: 'NewsDetail', query: { berita: 39 } }"
                  class="text-decoration-none link-list-style">
                  {{ $t('navigation.directory') }}
                </router-link>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="12" class="d-flex align-center px-md-0 pb-md-0">
            <router-link :to="{ name: 'Landing' }" class="d-inline-flex align-center text-decoration-none">
              <img class="mr-1" :src="require('./assets/logo-pnb.png')" height="55" :alt="apptitle"/>
              <img class="mr-3" :src="require('./assets/logo-bluspeed.png')" height="55" :alt="apptitle"/>
              <v-toolbar-title v-show="!$vuetify.breakpoint.smAndDown">
                <div class="title-style-pnb title-style-pnb text-uppercase">{{ apptitle }}</div>
                <div class="title-style-pnb subtitle-style-pnb">{{ appsubtitle }}</div>
              </v-toolbar-title>
              <v-toolbar-title v-show="$vuetify.breakpoint.smAndDown">
                <div class="title-style-pnb title-style-pnb">PNB</div>
              </v-toolbar-title>
            </router-link>
            <v-spacer v-if="false"></v-spacer>
            <v-btn
              v-show="!$vuetify.breakpoint.smAndDown"
              icon
              exact
              v-if="false">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <!-- mobile -->
            <v-col
              v-show="$vuetify.breakpoint.smAndDown"
              class="text-right">
              <ul class="top-nav-list">
                <li>
                  <SwitchLanguage />
                </li>
              </ul>
            </v-col>
            <v-btn
              v-show="$vuetify.breakpoint.smAndDown"
              icon
              @click.stop="rightDrawerPub = !rightDrawerPub">
              <v-icon>menu</v-icon>
            </v-btn>
          </v-col>
          <!-- desktop -->
          <v-col cols="12" md="12" class="px-md-0" v-show="!$vuetify.breakpoint.smAndDown">
            <div class="d-flex align-center">
              <v-btn
                tile
                class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                plain
                :to="{ name: 'Landing' }"
                exact
                active-class="active-class-style">
                {{ $t('navigation.home') }}
              </v-btn>
              <v-menu
                offset-y
                transition="slide-y-transition"
                bottom
                left
                content-class="pnbstyle-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                    plain
                    exact
                    active-class="active-class-style"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('navigation.study') }}
                    <v-icon
                      right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :to="{ name: 'Study' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.study') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'Course' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.course') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'NewsDetail', query: { berita: 152 } }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.calendar') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                tile
                class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                plain
                :to="{ name: 'Research' }"
                exact
                active-class="active-class-style">
                {{ $t('navigation.research') }}
              </v-btn>
              <v-btn
                tile
                class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                plain
                :to="{ name: 'Community' }"
                exact
                active-class="active-class-style">
                {{ $t('navigation.community') }}
              </v-btn>
              <v-menu
                offset-y
                transition="slide-y-transition"
                bottom
                left
                content-class="pnbstyle-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                    plain
                    exact
                    active-class="active-class-style"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('navigation.cooperation') }}
                    <v-icon
                      right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :to="{ name: 'Cooperation' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.cooperation') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'Collaboration' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.collaboration') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'Partner' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.partner') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                tile
                class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                plain
                href="https://p4mp.pnb.ac.id/"
                target="_blank"
                exact
                active-class="active-class-style">
                {{ $t('navigation.p4mp') }}
              </v-btn>
              <v-menu
                offset-y
                transition="slide-y-transition"
                bottom
                left
                content-class="pnbstyle-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                    plain
                    active-class="active-class-style"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('navigation.about') }}
                    <v-icon
                      right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :to="{ name: 'About' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.ourstory') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'NewsDetail', query: { berita: 61 } }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.strategic') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'NewsDetail', query: { berita: 66 } }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.bluspeed') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'NewsDetail', query: { berita: 40 } }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.reportperform') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'NewsDetail', query: { berita: 60 } }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.reportfin') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'News' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.info') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :to="{ name: 'Contact' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.contact') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                offset-y
                transition="slide-y-transition"
                bottom
                left
                content-class="pnbstyle-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                    plain
                    exact
                    active-class="active-class-style"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('navigation.campuslife') }}
                    <v-icon
                      right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :to="{ name: 'Pkkmb' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.pkkmb') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :to="{ name: 'Campuslife' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.campuslife') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :to="{ name: 'Alumni' }"
                    exact>
                    <v-list-item-title>
                      {{ $t('navigation.alumni') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                v-if="$i18n.locale === 'id'"
                tile
                class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
                plain
                :to="{ name: 'NewsDetail', query: { berita: 25 } }"
                exact
                active-class="active-class-style">
                <v-badge color="error" content="!" inline>
                  {{ $t('navigation.admission') }}
                </v-badge>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                exact
                href="https://www.facebook.com/PoltekBali/"
                target="_blank">
                <v-icon :color="maincolor">mdi-facebook</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                exact
                href="https://www.youtube.com/c/PoliteknikNegeriBaliOfficial"
                target="_blank">
                <v-icon :color="maincolor">mdi-youtube</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <!-- drawer - public -->
    <v-navigation-drawer
      v-if="useremail === ''"
      v-model="rightDrawerPub"
      temporary
      width="300"
      fixed
      right>
      <v-list>
        <v-list-group
          v-for="item in menupub"
          :key="item.title"
          v-model="item.active"
          :no-action="item.items.length > 0"
          :append-icon="item.items.length > 0 ? '$vuetify.icons.expand' : ''">
          <template v-slot:activator>
            <v-list-item
              v-if="item.items.length <= 0 && (item.path)"
              :href="item.path"
              target="_blank"
              exact>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="item.items.length <= 0 && !(item.path)"
              :to="item.to"
              exact>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.items.length > 0" exact>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div
            class="pl-8"
            v-for="subItem in item.items"
            :key="subItem.title">
            <v-list-item
              v-if="(subItem.path)"
              :href="subItem.path"
              target="_blank"
              exact>
              <v-list-item-content>
                <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="!(subItem.path)"
              :to="subItem.to"
              exact>
              <v-list-item-content>
                <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-group>
        <v-list-group
          :append-icon="''">
          <template v-slot:activator>
            <v-list-item
              :to="{ name: 'NewsDetail', query: { berita: 25 } }"
              exact>
              <v-list-item-content>
                <v-list-item-title>
                  <v-badge color="error" content="!" inline>
                    {{ $t('navigation.admission') }}
                  </v-badge>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <!-- drawer - private -->
    <v-navigation-drawer
      v-if="useremail !== ''"
      v-model="rightDrawer"
      temporary
      fixed
      right>
      <div>
        <v-list>
          <v-list-item
            v-for="(item, i) in menunavshow"
            :key="i"
            link
            :to="item.to">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <template v-slot:append v-if="tokenscr">
        <div class="pa-2">
          <v-btn color="error" tile depressed block @click="doLogout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-footer color="black" dark>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <div class="headline mb-2">Quick Link</div>
            <div class="mt-5">
              <div
                class="mb-1"
                v-for="(item, i) in pubmenu"
                :key="i">
                <router-link :to="item.to" class="white--text">
                  {{ $t(item.title) }}
                </router-link>
              </div>
              <div
                class="mb-1">
                <a class="white--text" href="https://sipol.pnb.ac.id/" target="_blank">
                  {{ $t('navigation.complain') }}
                </a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">External Link</div>
            <div class="mt-5">
              <div class="mb-1">
                <a href="https://dikti.kemdikbud.go.id/" target="_blank" class="white--text">
                  Kemenristekdikti
                </a>
              </div>
              <div class="mb-1">
                <a href="https://www.vokasi.kemdikbud.go.id/" target="_blank" class="white--text">
                  Kementrian Vokasi
                </a>
              </div>
              <div class="mb-1">
                <a href="https://politeknik.or.id/" target="_blank" class="white--text">
                  Politeknik Negeri se-Indonesia
                </a>
              </div>
              <div class="mb-1">
                <a href="https://pddikti.kemdikbud.go.id/" target="_blank" class="white--text">
                  Pangkalan Data Perguruan Tinggi
                </a>
              </div>
              <div class="mb-1">
                <a href="http://simlitabmas.ristekdikti.go.id/" target="_blank" class="white--text">
                  Simlibtamas
                </a>
              </div>
              <div class="mb-1">
                <a href="https://bidikmisi.belmawa.ristekdikti.go.id/" target="_blank" class="white--text">
                  Bidikmisi
                </a>
              </div>
              <div class="mb-1">
                <a href="http://spmi.kemdikbud.go.id/" target="_blank" class="white--text">
                  SPMI Pusat
                </a>
              </div>
              <div class="mb-1">
                <a href="http://simkatmawa.kemdikbud.go.id/" target="_blank" class="white--text">
                  Simkatmawa
                </a>
              </div>
              <div class="mb-1" v-if="false">
                <a href="https://www.lapor.go.id/" target="_blank" class="white--text">
                  Lapor.go.id
                </a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">Follow Us</div>
            <div class="mt-5">
              <v-btn
                class="mr-2"
                small
                fab
                outlined
                href="https://www.facebook.com/PoltekBali/"
                target="_blank">
                <v-icon>
                  mdi-facebook
                </v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                small
                fab
                outlined
                href="https://www.youtube.com/c/PoliteknikNegeriBaliOfficial"
                target="_blank">
                <v-icon>
                  mdi-youtube
                </v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                small
                fab
                outlined
                href="https://www.instagram.com/politeknik_negeri_bali"
                target="_blank">
                <v-icon>
                  mdi-instagram
                </v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                small
                fab
                outlined
                href="https://id.linkedin.com/school/politeknik-negeri-bali/"
                target="_blank">
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">{{ apptitle }}</div>
            <div class="mt-5">
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    mdi-map-marker
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  Kampus Politeknik Negeri Bali, Bukit Jimbaran, Kuta Selatan, Badung - Bali 80361 <br>
                  PO BOX 1064 Tuban
                </div>
              </div>
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    phone
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  +62 (0361)701981
                </div>
              </div>
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    email
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  poltek@pnb.ac.id
                </div>
              </div>
            </div>
          </v-col>
          <v-col
            class="text-center"
            cols="12">
            <v-divider dark></v-divider>
          </v-col>
          <v-col
            class="text-center"
            cols="12">
            Copyright &copy; {{ new Date().getFullYear() }} All rights reserved by <strong> {{ appname }}</strong>
          </v-col>
        </v-row>
      </v-container>
      <!-- tombol -->
      <v-fab-transition>
        <v-btn
          :color="maincolor"
          fab
          large
          dark
          bottom
          right
          fixed
          href="mailto:poltek@pnb.ac.id?subject=PENGADUAN"
          class="v-btn--example">
          <v-icon>mdi-chat-question</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue';
import SwitchLanguage from '@/components/SwitchLanguage.vue';
import { mapState } from 'vuex';
import qs from 'qs';

export default Vue.extend({
  name: 'App',
  components: {
    SwitchLanguage,
  },
  data: () => ({
    // defaultLanguage: 'en',
    defaultLanguage: 'id',
    appname: process.env.VUE_APP_NAME,
    apptitle: process.env.VUE_APP_TITLE,
    appsubtitle: process.env.VUE_APP_SUBTITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    darktheme: process.env.VUE_APP_DARK,
    rightDrawer: false,
    rightDrawerPub: false,
    notif: [],
    menupub: [],
    pubmenu: [
      {
        title: 'navigation.home',
        to: { name: 'Landing' },
      },
      {
        title: 'navigation.study',
        to: { name: 'Study' },
      },
      {
        title: 'navigation.researchand',
        to: { name: 'Research' },
      },
      {
        title: 'navigation.community',
        to: { name: 'Community' },
      },
      {
        title: 'navigation.cooperation',
        to: { name: 'Cooperation' },
      },
      {
        title: 'navigation.partner',
        to: { name: 'Partner' },
      },
    ],
    menunav: [
      {
        title: 'About PNB',
        icon: 'mdi-account-hard-hat',
        to: { name: 'About' },
        role: ['public'],
      },
      {
        title: 'Education',
        icon: 'mdi-domain',
        to: { name: 'Education' },
        role: ['public'],
      },
      {
        title: 'Research & Innovation',
        icon: 'mdi-domain',
        to: { name: 'Research' },
        role: ['public'],
      },
      {
        title: 'Community Services',
        icon: 'mdi-domain',
        to: { name: 'Community' },
        role: ['public'],
      },
      {
        title: 'Partnership',
        icon: 'mdi-domain',
        to: { name: 'Partner' },
        role: ['public'],
      },
      {
        title: 'Campus Life',
        icon: 'mdi-domain',
        to: { name: 'Campuslife' },
        role: ['public'],
      },
      {
        title: 'Login',
        icon: 'lock',
        to: { name: 'Login' },
        role: ['public'],
      },
      {
        title: 'Kelola Info',
        icon: 'mdi-information-variant',
        to: { name: 'Infoadmin' },
        role: ['admin'],
      },
      {
        title: 'Jurusan',
        icon: 'mdi-school',
        to: { name: 'JurusanAdmin' },
        role: ['admin'],
      },
      {
        title: 'Prodi',
        icon: 'mdi-cast-education',
        to: { name: 'ProdiAdmin' },
        role: ['admin'],
      },
      {
        title: 'Kelola Jurnal',
        icon: 'mdi-book-open-outline',
        to: { name: 'Journaladmin' },
        role: ['admin'],
      },
      {
        title: 'Produk Unggulan',
        icon: 'mdi-tools',
        to: { name: 'Productadmin' },
        role: ['admin'],
      },
      {
        title: 'Mitra PNB',
        icon: 'mdi-account-group',
        to: { name: 'Mitraadmin' },
        role: ['admin'],
      },
      {
        title: 'Change Password',
        icon: 'lock_open',
        to: { name: 'Changepassword' },
        role: ['admin'],
      },
    ],
    menunavshow: [],
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    loading: {
      berita: false,
    },
    btndash: 'Home',
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  beforeMount() {
    this.updateMenupub();
    const lang = !!localStorage.getItem('lang') ? localStorage.getItem('lang') : this.defaultLanguage;
    this.$i18n.locale = lang;
    this.$i18n.setLocaleMessage(lang, require(`./assets/lang/${lang}.json`));
  },
  mounted() {
    // check tokensrc
    if (this.tokenscr && this.tokenscr !== '') {
      this.checkTokenscr();
    }
    // update menu if not watch
    this.menuByRole();
    // notif
    // this.getNotifikasi();
  },
  methods: {
    updateMenupub() {
      this.menupub = [
        {
          icon: 'apps',
          title: 'navigation.home',
          to: { name: 'Landing' },
          active: false,
          items: [],
        },
        {
          icon: 'location_city',
          title: 'navigation.study',
          to: { name: 'Study' },
          active: false,
          items: [
            {
              icon: 'terrain',
              title: 'navigation.study',
              to: { name: 'Study' },
            },
            {
              icon: 'hotel',
              title: 'navigation.course',
              to: { name: 'Course' },
            },
            {
              icon: 'hotel',
              title: 'navigation.calendar',
              to: { name: 'NewsDetail', query: { berita: 152 } },
            },
          ],
        },
        {
          icon: 'local_activity',
          title: 'navigation.researchand',
          to: { name: 'Research' },
          active: false,
          items: [],
        },
        {
          icon: 'local_activity',
          title: 'navigation.community',
          to: { name: 'Community' },
          active: false,
          items: [],
        },
        {
          icon: 'local_activity',
          title: 'navigation.cooperation',
          to: { name: 'Cooperation' },
          active: false,
          items: [
            {
              icon: 'terrain',
              title: 'navigation.cooperation',
              to: { name: 'Cooperation' },
            },
            {
              icon: 'hotel',
              title: 'navigation.collaboration',
              to: { name: 'Collaboration' },
            },
            {
              icon: 'hotel',
              title: 'navigation.partner',
              to: { name: 'Partner' },
            },
          ],
        },
        {
          icon: 'terrain',
          title: 'navigation.p4mp',
          to: { name: 'Landing' },
          active: false,
          path: 'https://p4mp.pnb.ac.id/',
          items: [],
        },
        {
          icon: 'local_activity',
          title: 'navigation.about',
          to: { name: 'About' },
          active: false,
          items: [
            {
              icon: 'terrain',
              title: 'navigation.ourstory',
              to: { name: 'About' },
            },
            {
              icon: 'terrain',
              title: 'navigation.strategic',
              to: { name: 'NewsDetail', query: { berita: 61 } },
            },
            {
              icon: 'terrain',
              title: 'navigation.bluspeed',
              to: { name: 'NewsDetail', query: { berita: 66 } },
            },
            {
              icon: 'terrain',
              title: 'navigation.reportperform',
              to: { name: 'NewsDetail', query: { berita: 40 } },
            },
            {
              icon: 'terrain',
              title: 'navigation.reportfin',
              to: { name: 'NewsDetail', query: { berita: 60 } },
            },
            {
              icon: 'hotel',
              title: 'navigation.info',
              to: { name: 'News' },
            },
            {
              icon: 'hotel',
              title: 'navigation.contact',
              to: { name: 'Contact' },
            },
          ],
        },
        {
          icon: 'local_activity',
          title: 'navigation.campuslife',
          to: { name: 'Campuslife' },
          active: false,
          items: [
            {
              icon: 'hotel',
              title: 'navigation.pkkmb',
              to: { name: 'Pkkmb' },
            },
            {
              icon: 'terrain',
              title: 'navigation.campuslife',
              to: { name: 'Campuslife' },
            },
            {
              icon: 'hotel',
              title: 'navigation.alumni',
              to: { name: 'Alumni' },
            },
          ],
        },
      ];
    },
    menuByRole() {
      // dashboard btn
      if (this.userrole === 'admin') {
        this.btndash = 'Home';
      } else {
        this.btndash = 'DashboardJs';
      }
      // menu nav
      this.menunavshow = [];
      // console.log(this.userrole);
      for (const row of this.menunav) {
        if (this.userrole && this.userrole !== '') {
          if (row.role.indexOf(this.userrole) >= 0) {
            this.menunavshow.push(row);
          }
        } else {
          if (row.role.indexOf('public') >= 0) {
            this.menunavshow.push(row);
          }
        }
      }
    },
    getNotifikasi() {
      this.notif = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/surat/',
            {
              params: {
                status: 'request',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.notif = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkTokenscr() {
      this.axios
        .post(
          this.api + '/api/checktoken',
          qs.stringify(
            {
              token: this.tokenscr,
            },
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.tokenscr,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === true) {
              this.doLogout();
            }
          }
        })
        .catch((error) => {
          this.doLogout();
        });
    },
    doLogout() {
      this.$store.commit('AUTH_LOGOUT');
      this.$router.push({ name: 'Login' });
    },
  },
  watch: {
    userrole(val) {
      this.menuByRole();
    },
    tokenscr(val) {
      // this.getNotifikasi();
    },
  },
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $main-color: #333399;
  .title-style-pnb{
    font-family: 'Nunito' !important;
    color: $main-color !important;
    font-weight: bold;
    line-height: normal !important;
  }
  .title-style-pnb{
    font-size: 23px;
  }
  .subtitle-style-pnb{
    font-size: 11px;
  }
  .main-style-slide{
    color: $main-color !important;
  }
  .foot-list-icon{
    width: 40px;
  }
  .foot-list-content{
    display: table-cell;
    vertical-align: top;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .class-cursor{
    cursor: pointer;
  }
</style>
